"use client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createItemJson,
  fetchData,
  getOneItem,
} from "../../../../Api/hotelEndpoint";

/***------------- Get All Hotel Contact List Data ------------- ***/
export const fetchHotelContact = createAsyncThunk(
  "hotel/admin/fetchAll/hotelContact",
  async (params, { rejectWithValue }) => {
    try {
      const { data, totalPages, totalItems } = await fetchData({
        endpoint: "hotel/contactUs",
        ...params,
      });
      return { data, totalPages, totalItems };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

/***------------- Create Hotel Contact ------------- ***/
export const createHotelContact = createAsyncThunk(
  "hotel/contact/create",
  async ({ formData }, { rejectWithValue }) => {
    try {
      const data = await createItemJson({
        endpoint: "hotel/createOrUpdateContactUs",
        formData,
      });
      if (data) {
        return data;
      } else throw new Error("Request failed");
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

/***------------- Get Hotel Contact ------------- ***/
export const fetchOneContact = createAsyncThunk(
  "hotel/contact/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const data = await getOneItem(`hotel/getOneContactDetails`);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
